import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import Interview from './pages/Interview';
import InterviewPage from './pages/interviewPage';
import AdminDashboard from './pages/AdminDashboard';
import Profile from './pages/Profile';
import InterviewReport from './pages/InterviewReport';
import { Login } from './pages/Login';
import { Signup } from './pages/Register';
import Dashboard from './pages/Dashboard';
import InterviewDetails from './pages/InterviewDetails';
import DashboardLayout from './components/layout/DashboardLayout';
import CompletedInterviews from './components/dashboard/CompletedInterviews';
import './App.css';
import NotFound from './notfound';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SocketProvider>
          <Router>
            <div className="min-h-screen bg-gray-50">
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />

                {/* Dashboard routes with layout */}
                <Route path="/dashboard" element={<DashboardLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="assessment/:id" element={<Dashboard />} />
                  <Route path="assessment/:id/interviews" element={<CompletedInterviews />} />
                  <Route path="candidates" element={<Dashboard />} />
                  <Route path="profile" element={<Profile />} />
                </Route>

                <Route path="*" element={<NotFound />} /> 

                <Route
                  path="/interview"
                  element={
                      <Interview />
                  }
                />

               
                 
                  
                <Route
                  path="/report/:sessionid"
                  element={<InterviewReport />}
                />

                <Route
                  path="/details"
                  element={<InterviewDetails />}
                />
              </Routes>
              <Toaster
                position="bottom-center"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
            </div>
          </Router>
        </SocketProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
